import type { IconProps } from '../create-icon'

// Official VALORANT Sentinel role glyph (traced from Riot's role displayIcon).
// Filled disc with the symbol punched out as negative space — matches in-game art.
export function ValSentinel({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <g transform="translate(0,128) scale(0.1,-0.1)">
        <path d="M500 1254 c-92 -19 -214 -83 -288 -149 -34 -31 -62 -61 -62 -66 0 -5 200 -9 490 -9 290 0 490 4 490 9 0 22 -131 126 -205 162 -134 66 -281 84 -425 53z M24 808 c-14 -47 -18 -93 -18 -183 1 -103 4 -131 27 -193 55 -158 166 -288 304 -360 74 -38 199 -79 210 -68 6 6 -489 866 -498 866 -4 0 -15 -28 -25 -62z M1218 850 c-53 -84 -488 -844 -484 -847 2 -2 32 3 67 12 132 34 266 123 346 229 55 74 75 112 105 202 31 92 32 277 2 369 l-20 60 -16 -25z M342 811 c8 -24 294 -511 299 -511 7 0 299 502 299 513 0 4 -135 7 -301 7 -179 0 -299 -4 -297 -9z" />
      </g>
    </svg>
  )
}
